export const types = {
    adminUsersLoaded: '[admin] Admin user list loaded',
    adminSelected: '[admin] Admin user selected to edit',
    adminRegistered: '[admin] Admin user registered',
    adminUpdated: '[admin] Admin user updated',
    adminDeleted: '[admin] Admin user deleted',
    
    blogListLoaded: '[blog] Blog posts loaded',
    blogInEdition: '[blog] Blog is being edited',
    blockInEdition: '[blog] Block is being edited',
    blogSaved: '[blog] Post saved',
    blogUpdated: '[blog] Post updated',
    blogDeleted: '[blog] Post deleted',
    blogCategorySelected: '[blog] Categories were loaded',
    blogCategorySaved: '[blog] Category saved',
    blogCategoryDeleted: '[blog] Category deleted',
    nefroBlogLoaded: '[blog] Nefrópolis blog loaded',

    checkoutTaxSystem: '[checkout] Tax system data loaded',
    checkoutCFDI: '[checkout] CFDI data loaded',
    
    couponsLoaded: '[coupon] Coupons loaded',
    couponCloseModal: '[coupon] Close coupon modal',
    couponEdit: '[coupon] Coupon is being edited',
    couponUpdated: '[coupon] Coupon updated',
    couponDeleted: '[coupon] Coupon deleted',
    couponSelected: '[coupon] Coupon selected',
    couponsSelectedDeleted: '[coupon] Coupons selected deleted',

    categoriesLoaded: '[category] Product categories & brands loaded',
    categoryAdded: '[category] Product category added',
    categoriesDeleted: '[category] Product categories deleted',
    categoriesUpdated: '[category] Product categories updated',
    categoryDeleted: '[category] Product category deleted',
    subcategoryAdded: '[category] Subcategory added',
    subcategoryDeleted: '[category] Subcategory deleted',
    categoryImgUpdated: '[category] Image updated',

    brandAdded: '[brand] Product brand added',
    brandsDeleted: '[brand] Product brand(s) deleted',
    brandUpdated: '[brand] Product brand(s) updated',

    doctorsLoaded: '[doctor] Doctor list loaded',
    doctorUpdated: '[doctor] Doctor updated',
    doctorDeleted: '[doctor] Doctor deleted',

    productMinListLoaded: '[product] Minimal list loaded',
    productListLoading: '[product] Full list loading',
    productListLoaded: '[product] Full list loaded',
    productDraftsLoading: '[product] Draft list loading',
    productDraftsLoaded: '[product] Draft list loaded',
    productDraftUpdated: '[product] Draft updated',
    productDraftDeleted: '[product] Draft deleted',
    productDefault: '[product] Product reset',
    productActive: '[product] Product is active',
    productEdit: '[product] Product is being edited',
    productCloseModal: '[product] Product is no longer being edited',
    productUpdated: '[product] Product updated',
    productDeleted: '[product] Product and variants deleted',
    productSnackbarOpen: '[product] Variant images uploaded (open snackbar)',
    productSnackbarClose: '[product] Variant images uploaded (close snackbar)',

    activeVariants: '[product] Product variants are shown',
    variantEdit: '[product] Variant is being edited',
    variantSaved: '[product] Variant saved',
    variantUpdated: '[product] Variant updated',
    variantDeleted: '[product] Variant deleted',
    variantCloseModal: '[product] Variant is no longer being edited',
    
    ui_categoryToggle: '[ui] Category toggle change',
    ui_adminUserModal: '[ui] AdminUserList modal',
    ui_adminUserDialog: '[ui] AdminUserList dialog',
    ui_loginModal: '[ui] LoginComponent modal',
    ui_formsModal: '[ui] Forms modal',
    ui_commentLoading: '[ui] Comment process loading',
    ui_commentModal: '[ui] Comment modal',
    ui_shopSnackbar: '[ui] Shop snackbar',
    uiLoading2: '[ui] Saving blog (admin)',
    uiShopProductData: '[ui] Product data loading finished',
    uiLoginCodeModal: '[ui] Login code modal [/login]',
    userOrdersTab: '[ui] User orders tab [/mi-cuenta/mis-pedidos]',
    uiShopProductModal: '[ui] Shop product added to cart',
    
    shippingMethodsLoaded: '[shop] Nefrópolis shipping methods loaded',
    shippingMethodSelected: '[shop] Shipping method selected',
    shippingMethodSaved: '[shop] Shipping method saved',
    shippingMethodsDeleted: '[shop] Shipping methods deleted',
    shopProductsLoaded: '[shop] Nefrópolis products loaded',
    shopInfoLoaded: '[shop] Product categories and shop banners loaded',
    shopCouponsLoaded: '[shop] Shop coupons loaded',
    checkoutFillData: '[shop] Fill order data (shipping/billing)',
    checkoutOrderData: '[shop] Full order data',
    checkoutPaymentData: '[shop] Order payment data (payment-url)',
    checkoutPaymentResolved: '[shop] Pending order payment resolved',
    shoppingCart: '[shop] Shopping cart loaded',
    shopUpdateQuantity: '[shop] Update product quantity in shopping cart',
    shopEmptyCart: '[shop] Empty shopping cart',
    shopCoupon: '[shop] Coupon applied to shopping cart',
    shopProductViewed: '[shop] Shop product viewed',

    reviewAdded: '[shop] Review made',
    reviewSelected: '[shop] Review is active',
    reviewUpdated: '[shop] Review updated',
    reviewDeleted: '[shop] Review deleted',
    reviewSummaryUpdated: '[shop] Review summary updated',

    form1Submitted: '[form] Complaints & suggestions form',
    form2Submitted: '[form] Postulation form',
    form3Submitted: '[form] Distributors form',
    form1Backdrop: '[form] Complaints & suggestions backdrop',
    form2Backdrop: '[form] Postulation backdrop',
    form3Backdrop: '[form] Distributors backdrop',
    formListLoaded: '[form] Form list loaded',
    formRegistered: '[form] Form registered',
    formReset: '[form] Form fields reset',

    userLoggedIn: '[user] User logged in',
    userLoggedOut: '[user] User logged out',
    loadingDone: '[user] User token loading done',
    clearRdrPage: '[user] Clear redirection page',
    userOrderList: '[user-account] Order list loaded (mi-cuenta)',
    userMoreOrders: '[user-account] More orders were loaded',
    userOrderSelected: '[user-account] Approved order selected',
    userOrderUpdated: '[user-account] Inactive order updated',
    userOrderRemoved: '[user-account] Order removed from list',
    userOrderRestored: '[user-account] Order restored to list'
};
